//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { IInstagramBusinessIdResponse } from '@apis/gateway-instagram/gatewayInstagramApiModel';
import Cuid from '@models/Cuid';
import InstagramUsername from '@models/InstagramUsername';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

function gatewayInstagramFetch(
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> {
  return serializedGatewayFetch(
    'instagram_dashboard_gateway',
    `/api/v1/instagram${endpoint}`,
    init,
  );
}

// Fetches the business id using a random graph api token (useful for connect)
export async function getBusinessUser(
  username: string,
): Promise<IInstagramBusinessIdResponse> {
  const res = await gatewayInstagramFetch(`/username/${username}/business-id`);
  return await res.json();
}

// Fetches the business id using the graph api token for the connected instagram account
export async function getBusinessUserForClient(
  username: InstagramUsername,
): Promise<IInstagramBusinessIdResponse> {
  const res = await gatewayInstagramFetch(
    `/username/${username}/business-id-for-client`,
  );
  return await res.json();
}

// Fetches the comment export using the graph api token for the connected instagram account
export async function getCommentExport(exportId: string): Promise<Response> {
  return await gatewayInstagramFetch(`/comments/export?exportId=${exportId}`);
}

// Exports comments to user email. Copying function from API here to allow access from React components.
export async function exportCommentsToEmail(cuid: Cuid): Promise<void> {
  await gatewayInstagramFetch(`/comments/export`, {
    method: 'POST',
    body: JSON.stringify({
      cuid,
    }),
  });
}
